import { type ReactElement } from 'react'
import type { KNFormProps } from './types'
import Box from '@mui/material/Box'

const KNForm = ({
  onSubmit,
  sx,
  children,
}: KNFormProps): ReactElement => (
  <Box
    component="form"
    onSubmit={onSubmit}
    sx={sx}
  >
    {children}
  </Box>
)

export default KNForm
